import React from 'react';
import { UniversalEditorContext } from '../context/universal-editor-context';
import { createUniversalEditorFilterId, findModelAndFragmentForPath, } from '../utils';
import { isContentFragment, isContentFragmentArray } from '../../content-types';
import { UeElement } from './ue-element';
export const UeContainer = ({ propertyPath, label, children, as, }) => {
    const ueContext = React.useContext(UniversalEditorContext);
    const { filter, lastProperty } = React.useMemo(() => {
        if (!ueContext.isAuthorMode || !ueContext.isFalconContent) {
            return { filter: '', lastProperty: '' };
        }
        const modelAndFragment = findModelAndFragmentForPath(ueContext.rawCmsContent, propertyPath);
        if (!isContentFragment(modelAndFragment?.fragment) &&
            !isContentFragmentArray(modelAndFragment?.fragment)) {
            console.warn(`We could not find a ContentFragment or ContentFragment[] for the propertyPath "${propertyPath}"`);
        }
        return {
            filter: createUniversalEditorFilterId(modelAndFragment?.parentModel?.path, modelAndFragment?.lastPropertyName),
            lastProperty: modelAndFragment?.lastPropertyName,
        };
    }, [propertyPath, ueContext]);
    return (React.createElement(UeElement, { type: "container", property: lastProperty, label: label, as: as, filter: filter }, children));
};
//# sourceMappingURL=ue-container.js.map